export default {
  'meta': {
    'langName': 'ROMANIAN',
    'lang': 'Română'
  },
  'title': 'RETRAGERE PRODUS: TROTINETĂ ELECTRICĂ SD500E sau MD500E de la marca BTWIN',
  'description': 'Bună ziua,\n\nAți achiziționat o trotinetă electrică marca BTWIN, modelul SD500E sau MD500E, și vă mulțumim pentru achiziția dumneavoastră.\n\nSiguranța dumneavoastră este prioritatea noastră, de aceea vă rugăm să citiți cu atenție următoarele informații.\n\nÎn ciuda unor proceduri riguroase de control al calității, am identificat un defect de siguranță la trotinetele electrice marca BTWIN, modelele SD500E și MD500E. Utilizarea intensivă poate duce la apariția unei fisuri la îmbinarea dintre cadru și coloana de direcție . Acest defect poate cauza ruperea acestei îmbinări, generând un risc de cădere pentru utilizator.\n\nVă sugerăm să răspundeți la următoarele întrebări, astfel încât să vă putem oferi o soluție de siguranță pentru produsul dumneavoastră.\n\nNe cerem scuze pentru orice neplăcere cauzată și vă mulțumim pentru încredere.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'În primul rând, ați putea, vă rog, să confirmați adresa dumneavoastră de email și țara de reședință:'
  },
  'fields': {
    'country': 'Tara',
    'address': 'Adresa e-mail',
    'email': 'Adresa e-mail',
    'phonePrefix': 'Prefixul international al numarului de telefon',
    'phone': 'Număr de telefon',
    'validations': {
      'phoneOrEmail': 'Vă rugăm să ne furnizați cel puțin o adresă de email sau un număr de telefon.',
      'email': 'Te rog să introduci o adresă de email validă',
      'phone': 'Te rog să introduci un număr de telefon valid',
      'selectAddress': 'Vă rugăm să selectați o adresă completă din listă (număr, numele străzii și orașul).',
      'incompleteAddress': 'Adresa trebuie să includă un număr, numele străzii și orașul.Introduceți cel puțin numărul și strada, apoi alegeți o sugestie.'
    },
    'firstName': 'Nume',
    'lastName': 'Prenume',
    'deliveryAddress': 'Adresa de livrare pentru pachet',
    'additionalAddress': 'Informatii suplimentare adresă',
    'city': 'Oras',
    'zip': 'Cod Postal',
    'readConfirmation': 'Certific faptul că datele mele de contact sunt corecte, confirm că am citit termenii și condițiile furnizate și sunt de acord să le respect.',
    'choose': 'Selectează',
    'required': 'Acest câmp este obligatoriu',
    'deliveryAddressHelp': 'Introduceți numărul și numele străzii dumneavoastră, apoi alegeți o adresă completă din listă.',
    'streetOnlyHint': 'Adăugați un număr de stradă'
  },
  'ownerCheck': {
    'title': 'Mai dețineți una sau mai multe trotinete electrice BTWIN SD500E și MD500E?'
  },
  'yes': 'DA',
  'no': 'NU',
  'ownerChanged': {
    'title': 'Ai datele de contact ale actualului(lor) proprietar(i)?',
    'confirmation': '---\nDomnule/Doamnă,\n\nVă mulțumim pentru participarea la această inițiativă de calitate.\n\nNe cerem scuze pentru neplăcerile create și vă mulțumim pentru încredere.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Vă rugăm să ne indicați cantitatea de trotinete electrice BTWIN, modelele SD500E și MD500E, pe care le dețineți.',
    'descriptionSd500': 'trotinete electrice SD500E',
    'descriptionEmd500e': 'trotinete electrice MD500E',
    'modelNumberHelp': 'Puteți găsi numărul modelului (SD500E sau MD500E) pe partea inferioară a trotinetei dumneavoastră, așa cum este prezentat mai jos.',
    'quantity': 'Cantitatea',
    'confirmation': 'Vă mulțumim pentru completarea acestui formular. Solicitarea dumneavoastră a fost înregistrată cu succes.\n\nVă vom informa în termen de maximum 20 de zile cu privire la data de la care veți putea efectua reparația.\n\nO zi excelentă!\n\nDECATHLON'
  },
  'repair': {
    'title': 'Reparație cu participarea ta',
    'description': 'Vă rugăm să nu îl mai utilizați.\n\nUn kit de reparație și instrucțiunile aferente vor fi trimise la domiciliul dumneavoastră, astfel încât să vă puteți securiza trotineta. Acest kit vă va fi trimis gratuit; este rapid și ușor de asamblat.\n\nDupă colectarea informațiilor dumneavoastră, vă vom contacta în termen de maximum 20 de zile pentru a vă confirma când va fi disponibil kitul de reparație. Vă asigurăm că se vor depune toate eforturile pentru a reduce aceste termene, în scopul de a vă satisface cerințele.',
    'kitLabel': 'Kit complet de reparație',
    'docLabel': 'Instrucțiuni de reparație',
    'callToAction': 'Faceți clic aici pentru a primi kitul de reparație gratuit',
    'infoConfirmation': 'Vă rugăm să verificați datele introduse',
    'validateConfirmation': 'Confirmă',
    'backConfirmation': 'Inapoi'
  },
  'repairRequest': {
    'title': 'Vă rugăm să introduceți următoarele informații pentru a primi kitul de reparație:'
  },
  'form': {
    'submit': 'Următorul'
  },
  'status': 'Translation validated by COUNTRY'
} as const
